import React, { useEffect } from "react";
import "./TaskEditor.css";

interface ConfirmDialogProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ message, onConfirm, onCancel }) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
      if (e.key === "Enter") onConfirm();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onConfirm, onCancel]);

  return (
    <div className="task-editor-overlay" onClick={onCancel}>
      <div className="task-editor" style={{ width: 380 }} onClick={(e) => e.stopPropagation()}>
        <div className="task-editor-header">
          <h2>Confirm</h2>
          <button className="task-editor-close" onClick={onCancel}>&#x2715;</button>
        </div>
        <div className="task-editor-body">
          <p style={{ margin: 0, fontSize: 14, color: "inherit" }}>{message}</p>
        </div>
        <div className="task-editor-footer">
          <div className="task-editor-footer-left" />
          <div className="task-editor-footer-right">
            <button className="task-editor-btn task-editor-btn-cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="task-editor-btn task-editor-btn-delete" style={{ background: "#e53935", color: "#fff", padding: "9px 20px" }} onClick={onConfirm}>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
